export default {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
  REJECT_SPOS: 'update:reject_spos',
  ADDITIONAL_SPOS: 'update:additional',
  APPROVE_SPOS: 'update:approved-step1',
  RECEIVE_APPRAISE_SPOS: 'update:receive-appraiser',
  ASSIGN_APPRAISER: 'update:assign-appraiser',
  EXPORT_MID_TID: 'create:export-mid-tid',
  VIEW_LIST_SPOS: 'read:list',
  APPROVE_SPOS_STEP_2: 'update:approved-step2',
  VIEW_DETAIL: 'read:detail',
  ADDITIONAL_SPOS_STEP2: 'update:additional-detail',
  REJECT_SPOS_STEP_2: 'update:reject-spos-detail',
  ASSIGN_APPRAISER_DETAIL: 'update:assign-detail',
  RECEIVE_APPRAISAL: 'update:receive-appraiser',
  UPDATE_DEVICE: 'update:update-device',
};
